import React from 'react'
import { Navigate, useNavigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

const WelcomePage: React.FC = () => {
  const { isAuthenticated, user } = useAuth()
  const navigate = useNavigate()

  if (isAuthenticated && user) {
    // Redirect authenticated users to their appropriate dashboard
    return <Navigate to="/dashboard" replace />
  }

  return (
    <div className="vh-100 d-flex align-items-center justify-content-center bg-light">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-8 col-lg-6 col-xl-5">
            <div className="card border-0" style={{
              boxShadow: '0 20px 40px rgba(2, 34, 91, 0.12), 0 8px 16px rgba(2, 34, 91, 0.08)',
              borderRadius: '16px'
            }}>
              <div className="card-body p-5 text-center">
                {/* FundMerica Logo */}
                <div className="mb-4">
                  <img 
                    src="https://www.fundmerica.com/wp-content/uploads/2017/12/FndMerica-logo.png" 
                    alt="FundMerica Logo" 
                    style={{ maxHeight: '40px', width: 'auto' }}
                    className="mb-3"
                  />
                </div>
                
                <div className="mb-4">
                  <h3 className="display-6 text-primary fw-normal mb-3">Partner Portal</h3>
                 
                </div>

                <div className="d-grid gap-3 mt-4">
                  <button 
                    onClick={() => navigate('/login')}
                    className="btn btn-primary btn-lg"
                  >
                    Sign In
                  </button>
                  <button 
                    onClick={() => navigate('/signup')}
                    className="btn btn-outline-primary btn-lg"
                  >
                    Create Account
                  </button>
                </div>

                <div className="mt-4 pt-3 border-top">
                  <small className="text-muted">
                    Secure portal for ISO deal submissions and management
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default WelcomePage